<template>
  <div style="padding:24px;">
    <el-row class="card">
      <el-col :span="8">
        <span>当前逾期状态：</span>
        <span>{{isDelay?'已逾期':'未逾期'}}</span>
      </el-col>
      <el-col :span="8">
        逾期时间：
        <span v-if="isDelay">{{DTFormat(delayTime)}}</span>
      </el-col>
      <el-col :span="8">
        逾期申请：
        <span v-if="isDelay">{{isApply?'已提交':'未提交'}}</span>
      </el-col>
    </el-row>
    <hr>
    <div class="card record" v-for="delay in delayList" :key="delay.ID">
      <div class="top">
        <span>{{delay.DELAYTYPENAME}}</span>
        <span
          class="state"
          :class="{pass:delay.APPROVALSTATENAME=='无需审核'||delay.APPROVALSTATENAME=='审核通过'}"
        >{{delay.APPROVALSTATENAME}}</span>
        <span class="dt">申请时间：{{DTFormat(delay.CREATETIME)}}</span>
      </div>
      <div class="card border detail">
        <div>
          申请时长：{{overdueDelay(delay)}}
          <el-button
            v-if="delay.CREATEUSERID==cookieUser.userId&&delay.DELAYTYPENAME=='未审核'"
            type="primary"
            size="mini"
            style="float:right;"
          >修改</el-button>
        </div>
        <div>
          申请内容
          <p>{{delay.MEMO}}</p>
        </div>
        <div>
          <span style="padding-right:12px;">审核人：{{delay.APPROVALUSERNAME||'-'}}</span>
          <span style="padding-right:12px;">批准时长：{{passDelay(delay)}}</span>
          <span>审核备注：{{delay.APPROVALMEMO||'-'}}</span>
        </div>
      </div>
    </div>
    <div style="padding-top:12px;">
      <el-button :disabled="!isDelay" type="primary">进度逾期申请</el-button>
      <el-button :disabled="!isDelay" type="primary">操作超期申请</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getTaskByTaskId,
  GetTaskDelayByTaskId
} from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  name: "SideTagsOverdue",
  data() {
    return {
      taskData: {},
      delayList: [],
      cookieUser: {}
    };
  },
  computed: {
    ...mapState({
      task: state => state.task.curTask,
      tabIndex: state => state.task.tabIndex
    }),
    isDelay() {
      return this.taskData.IsDelay;
    },
    delayTime() {
      return this.taskData.OVERTIME;
    },
    isApply() {
      // 是否提交了申请
      return this.delayList.length > 0;
    }
  },
  methods: {
    initalTask: function() {
      let _this = this;
      if (!this.task || this.tabIndex !== "12") return;
      getTaskByTaskId(this.task.ID, cookieUser.userId)
        .then(res => {
          _this.taskData = res;
          console.log(_this.task);
        })
        .catch(res => {
          console.log(res);
        });
      GetTaskDelayByTaskId(this.task.ID)
        .then(res => {
          this.delayList = res;
        })
        .catch(res => {
          console.log(res);
        });
      this.cookieUser = cookieUser;
    },
    DTFormat(dt) {
      if (!dt) return "";
      return dt.replace("T", " ").substr(0, 19);
    },
    overdueDelay(delay) {
      let unit = {
        0: "分钟",
        1: "小时",
        2: "天"
      };
      // 逾期时长
      return delay.DELAYNUM + unit[delay.DELAYUNIT];
    },
    passDelay(delay) {
      if (delay.APPROVALSTATENAME != "审核通过") return "-";
      // 批准时长
      let unit = {
        0: "分钟",
        1: "小时",
        2: "天"
      };
      // 逾期时长
      return delay.APPROVALDELAYNUM + unit[delay.APPROVALDELAYUNIT];
    }
  },
  watch: {
    task: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    },
    tabIndex: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    }
  }
};
</script>

<style scoped>
.top {
  margin-bottom: 24px;
}
.card {
  background-color: #fff;
  padding: 24px;
}
.border {
  border: 1px solid #ddd;
}
.record {
  font-size: 14px;
}
.detail > div {
  line-height: 24px;
}
.detail p {
  padding-left: 24px;
}
.state {
  padding-left: 11px;
  display: inline-block;
  color: red;
}
.state.pass {
  color: green;
}
.dt {
  float: right;
}
.el-button--mini {
  padding: 4px 6px;
}
</style>
